const getPatientWeight = ({ patient, value, showUnits = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient.Vitals[0]
    ? (showUnits ? `${patient.Vitals[0].Weight} lbs` : patient.Vitals[0].Weight) : null;
};

export default getPatientWeight;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientWeight.js